"use strict";

if (!customElements.get('s-header')) {
  customElements.define('s-header', class SectionHeader extends HTMLElement {
    constructor() {
      super();
      this.html = document.documentElement;
      this.headerSection = document.querySelector(".section-header");
      this.burger = this.querySelector(".header__burger");
      this.burgerMenu = this.querySelector(".header__list");
      this.headerNavItems = Array.from(this.querySelectorAll(".header__list a"));
      this.searchOpener = this.querySelector(".header__search-btn");
      this.searchCloser = this.querySelector(".header__search-closer");
      this.searchField = this.querySelector(".header__search");
      this.searchOverlay = document.querySelector(".header__search-overlay");
      if (!this.searchOverlay) {
        this.searchOverlay = document.createElement("div");
        this.searchOverlay.className = "header__search-overlay";
        document.body.append(this.searchOverlay);
      }
      this.submenuItems = Array.from(this.querySelectorAll(".header__list .has-submenu"));
      this.accountDropdown = this.querySelector(".header__account-dropdown");
      this.accountBtn = this.querySelector(".header__account-btn");
      this.mobileAccountMq = window.matchMedia("(max-width: 959px)");
      this.headerSimilar = null;
      this.boundResizeHandler = () => this.updateHeaderMetrics();

      this.initHeaderSpacing();
      this.bindMenuEvents();
      this.bindNavigationEvents();
      this.bindSearchEvents();
      this.bindSubmenuEvents();
      this.bindAccountEvents();
      this.bindGlobalEvents();
    }

    initHeaderSpacing() {
      this.updateHeaderMetrics();
      if (!this.headerSection) return;

      this.headerSimilar = document.createElement("div");
      this.headerSimilar.style.height = this.getHeaderHeight();
      this.headerSection.after(this.headerSimilar);
    }

    getHeaderHeight() {
      if (!this.headerSection) return "0px";
      return `${this.headerSection.clientHeight}px`;
    }

    updateHeaderMetrics() {
      const headerHeight = this.getHeaderHeight();
      this.html.style.setProperty("--header-overlay-offset", headerHeight);
      if (this.headerSimilar) this.headerSimilar.style.height = headerHeight;
    }

    isSearchOpen() {
      return !!(this.searchField && this.searchField.classList.contains("active"));
    }

    isMenuOpen() {
      return !!(this.burger && this.burger.classList.contains("header__burger--open"));
    }

    syncOverlayState() {
      if (!this.searchOverlay) return;
      this.searchOverlay.classList.toggle("active", this.isSearchOpen() || this.isMenuOpen());
    }

    bindMenuEvents() {
      if (!this.burger || !this.burgerMenu) return;

      this.burger.addEventListener("click", () => {
        this.burger.classList.toggle("header__burger--open");
        this.burgerMenu.classList.toggle("header__list--active", this.isMenuOpen());
        if (this.html) this.html.classList.toggle("no-scroll", this.isMenuOpen());
        this.syncOverlayState();
      });
    }

    bindNavigationEvents() {
      if (!this.headerNavItems.length) return;

      this.headerNavItems.forEach(item => {
        item.addEventListener("click", ev => {
          const href = item.getAttribute("href");
          if (!href || !href.startsWith("/#") || typeof findHeadingById !== "function") return;

          const popularSection = findHeadingById(href.slice(2));
          if (!popularSection) return;

          ev.preventDefault();
          ev.stopPropagation();
          const position = popularSection.offsetTop - popularSection.offsetHeight / 8;
          window.scrollTo({
            top: position,
            behavior: "smooth"
          });
        });
      });
    }

    bindSearchEvents() {
      if (this.searchOpener && this.searchField) {
        this.searchOpener.addEventListener("click", () => {
          this.searchField.classList.add("active");
          const input = this.searchField.querySelector(".c-search__input");
          if (input) input.focus();
          this.syncOverlayState();
        });
      }

      if (this.searchCloser) {
        this.searchCloser.addEventListener("click", () => {
          this.closeSearch();
        });
      }

      if (this.searchOverlay) {
        this.searchOverlay.addEventListener("click", () => {
          if (this.isSearchOpen()) this.closeSearch();
          if (this.isMenuOpen()) this.closeMenu();
        });
      }
    }

    bindSubmenuEvents() {
      if (!this.submenuItems.length) return;

      this.submenuItems.forEach(item => {
        const toggle = item.querySelector(".header__menu-row");
        if (!toggle) return;

        toggle.addEventListener("click", ev => {
          if (!this.mobileAccountMq.matches) return;
          ev.preventDefault();
          ev.stopPropagation();
          const isOpen = item.classList.contains("is-open");
          item.classList.toggle("is-open", !isOpen);
          toggle.setAttribute("aria-expanded", !isOpen ? "true" : "false");
        });
      });

      this.mobileAccountMq.addEventListener("change", (e) => {
        if (!e.matches) {
          this.submenuItems.forEach(item => {
            item.classList.remove("is-open");
            const toggle = item.querySelector(".header__menu-row");
            if (toggle) toggle.setAttribute("aria-expanded", "false");
          });
        }
      });
    }

    bindAccountEvents() {
      if (!this.accountBtn || !this.accountDropdown) return;

      this.accountBtn.addEventListener("click", ev => {
        if (!this.mobileAccountMq.matches) return;
        ev.preventDefault();
        ev.stopPropagation();
        const open = this.accountDropdown.classList.toggle("is-open");
        this.accountBtn.setAttribute("aria-expanded", open ? "true" : "false");
      });

      document.addEventListener("click", ev => {
        if (!this.mobileAccountMq.matches) return;
        if (!this.accountDropdown.classList.contains("is-open")) return;
        if (this.accountDropdown.contains(ev.target)) return;
        this.accountDropdown.classList.remove("is-open");
        this.accountBtn.setAttribute("aria-expanded", "false");
      });

      this.mobileAccountMq.addEventListener("change", () => {
        if (!this.mobileAccountMq.matches) {
          this.accountDropdown.classList.remove("is-open");
          this.accountBtn.setAttribute("aria-expanded", "false");
        }
      });
    }

    bindGlobalEvents() {
      window.addEventListener("resize", this.boundResizeHandler);
    }

    closeSearch() {
      if (!this.searchField) return;

      this.searchField.classList.remove("active");
      const input = this.searchField.querySelector('input[type="search"]');
      if (input) input.value = "";

      const predictive = this.searchField.querySelector('#predictive-search');
      if (predictive) predictive.innerHTML = "";

      const searchInput = this.searchField.querySelector('.c-search__input');
      if (searchInput) searchInput.blur();

      this.syncOverlayState();
    }

    closeMenu() {
      if (this.burger) this.burger.classList.remove("header__burger--open");
      if (this.burgerMenu) this.burgerMenu.classList.remove("header__list--active");
      if (this.html) this.html.classList.remove("no-scroll");
      this.syncOverlayState();
    }
  });
}

document.addEventListener('scroll', () => {
  const header = document.getElementById('shopify-section-header');
  if (!header) return;
  const scrollPosition = window.scrollY;

  if (scrollPosition > 100) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});